<template>
	<!-- 大盒子 -->
	<div class="content">
		<!-- 主体内容 -->
		<div class="main">
			<!-- 新增等Model -->
			<div class="addModel">
				<el-dialog
				  title="新增收费项目"
				  :visible.sync="dialogVisible"
				  width="48%"
				  :modal="false"
				  :before-close="handleClose">
				  <div class="form">
					<!-- 表单 -->
					<el-form :rules="addRules" :model="addForm" ref="addForm" size="mini">
						<el-row :gutter="20">
							<el-col :span="v.spanRows" type="flex" v-for="(v,i) in formType" :key="i">
							<!-- select - Other -->
							<el-form-item v-if="v.type == 'select1'" :label="v.label" :prop="v.modelValue">
								<div class="select-with-add-button">
									<el-select v-model="$data.addForm[v.modelValue]" :disabled="v.disabled ? addDisabled : v.disabled" filterable
									@focus="handlefoucs(v,i)" @change="handleChange" :filter-method="searchMethod" :popper-append-to-body="false">
										<el-option v-for="(item,index) in $data[v.op]" :key="index" :label="item.label" :value="item.id">
											<div id="optionItem">
												<span style="width: 48px;">{{ item.id }}</span>
												<el-tooltip class="item" effect="light" :content="item.chargeProjectName" placement="top">
												    <span style="text-align: left;">{{ item.chargeProjectName }}</span>
												</el-tooltip>
												<el-tooltip class="item" effect="light" :content="item.priceCode" placement="top">
												    <span>{{ item.priceCode }}</span>
												</el-tooltip>
												<el-tooltip class="item" effect="light" :content="item.description" placement="top">
												    <span style="width: 288px;text-align: left;">{{ item.description }}</span>
												</el-tooltip>
											</div>
										</el-option>
									</el-select>
									<el-button 
									  class="add-button" 
									  icon="el-icon-plus" 
									  size="mini" 
									  @click="openCustomChargeDialog"
									  title="新增自定义收费项目">
									</el-button>
								</div>
							</el-form-item>
							<!-- select -->
							<el-form-item v-if="v.type == 'select'" :label="v.label" :prop="v.modelValue">
								<el-select v-model="$data.addForm[v.modelValue]" @focus="handlefoucs(v,i)" @change="handleChange">
									<el-option v-for="item in $data[v.op]" :key="item.id" :label="item.label" :value="item.id">
										<div style="font-size: 12px;display: flex;justify-content: space-between;align-items: center;">
											<span>{{ item.label }}</span>
								<!-- 			<span>{{ item.id }}</span>
											<span>{{ item.code }}</span> -->
										</div>
									</el-option>
								</el-select>
							</el-form-item>
							<!-- input -->
							<el-form-item v-if="v.type == 'input'" :label="v.label" :prop="v.modelValue">
								<el-input v-model="$data.addForm[v.modelValue]" :disabled="v.disabled" @blur="inputChance(v,i)"></el-input>
							</el-form-item>
							<!-- textarea -->
							<el-form-item v-if="v.type == 'textarea'" :label="v.label" :prop="v.modelValue">
								<el-input type="textarea" :rows="3" v-model="$data.addForm[v.modelValue]"></el-input>
							</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				  </div>
				  
				  <!-- 新增自定义收费项目对话框 -->
				  <el-dialog
					title="新增自定义收费项目"
					:visible.sync="customChargeDialogVisible"
					width="40%"
					append-to-body
					:before-close="handleCustomClose">
					<el-form :model="customChargeForm" :rules="customChargeRules" ref="customChargeForm" size="mini">
					  <el-form-item label="项目名称：" prop="chargeProjectName" label-width="100px">
						<el-input v-model="customChargeForm.chargeProjectName" placeholder="请输入收费项目名称"></el-input>
					  </el-form-item>
					  <el-form-item label="价格编码：" prop="priceCode" label-width="100px">
						<el-input v-model="customChargeForm.priceCode" placeholder="请输入价格编码"></el-input>
					  </el-form-item>
					  <el-form-item label="项目描述：" prop="description" label-width="100px">
						<el-input type="textarea" v-model="customChargeForm.description" placeholder="请输入项目描述" :rows="3"></el-input>
					  </el-form-item>
					  <el-form-item label="适用对象：" prop="applicableObject" label-width="100px">
						<el-select v-model="customChargeForm.applicableObject" placeholder="请选择适用对象">
						  <el-option v-for="item in ObjectsOptions" :key="item.id" :label="item.label" :value="item.id"></el-option>
						</el-select>
					  </el-form-item>
					  <el-form-item label="标准价格：" prop="standardPrice" label-width="100px">
						<el-input v-model="customChargeForm.standardPrice" placeholder="请输入标准价格" type="number">
						  <template slot="append">元</template>
						</el-input>
					  </el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
					  <el-button size="mini" type="primary" @click="submitCustomCharge">确 定</el-button>
					  <el-button size="mini" @click="handleCustomClose">取 消</el-button>
					</span>
				  </el-dialog>
				  
				  <span slot="footer" class="dialog-footer">
				    <el-button size="mini" type="primary" @click="addSubmit">确 定</el-button>
				    <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
				  </span>
				</el-dialog>
			</div>
		</div>
	</div>
</template>

<script>
// self
import AddType from './AddType.js'
// import AccMainType from './AddPlanMainType.js'
import addForm from './addForm.js' //Form表单
import Pinyin from "@/external/pinyin.js"; //中译音
// 接口
import { getCostList,standardList,getCostType, getMREC, getSosTypes,addChargeProject, addCustomChargeProject } from "@/api/Outpatient/category.js";

	export default {
		props: ['parentMethod'],
		data() {
			return {
				// 新增数据
				customChargeDialogVisible: false,
				customChargeForm: {
				  chargeProjectName: '',
				  priceCode: '',
				  description: '',
				  applicableObject: '',
				  standardPrice: ''
				},
				customChargeRules: {
				  chargeProjectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
				  priceCode: [{ required: true, message: '请输入价格编码', trigger: 'blur' }],
				  applicableObject: [{ required: true, message: '请选择适用对象', trigger: 'change' }],
				  standardPrice: [{ required: true, message: '请输入标准价格', trigger: 'blur' }]
				},
				
				// 原有数据保持不变
				inputSearchValue:'',
				idx:0,
				pageNum: 1,
				pageSize: 28,
				totalSize: 10,
				dialogVisible:false,
				formType:[],
				selectChanceAll:[],
				CostIdOptions:[],
				ClassIdOptions:[],
				ObjectsOptions:[{id:0,label: '全部'},{id:1,label: '门诊'},{id:2,label: '住院'}, { id:3,label: '门诊和住院'}, {id:4,label: '打包明细'}],
				expenseCategoryIdOptions:[],
				statusOption:[{ id:0,label:'禁用',value:'禁用'},{ id:1,label:'可用',value:'可用'}],
				addRules:{
					chargeProjectName:[{ required:true,message:'此项必选',trigger:'change' }],
					expenseCategoryId:[{ required:true,message:'此项必选',trigger:'change' }],
					medicalRecordCostId:[{ required:true,message:'此项必选',trigger:'change' }],
				},
				addForm:{},
			}
		},
		mounted() {
			this.getForm();
			this.axiosGetCostType();
			this.axiosGetMREC();
		},
		methods: {
			// 新增方法：打开自定义收费项目对话框
			openCustomChargeDialog() {
			  this.customChargeDialogVisible = true;
			  this.resetCustomForm();
			},
			
			// 新增方法：关闭自定义收费项目对话框
			handleCustomClose() {
			  this.customChargeDialogVisible = false;
			  this.resetCustomForm();
			},
			
			// 新增方法：重置自定义表单
			resetCustomForm() {
			  this.customChargeForm = {
				chargeProjectName: '',
				priceCode: '',
				description: '',
				applicableObject: '',
				standardPrice: ''
			  };
			  if (this.$refs.customChargeForm) {
				this.$refs.customChargeForm.clearValidate();
			  }
			},
			
			// 新增方法：提交自定义收费项目
			async submitCustomCharge() {
			  this.$refs.customChargeForm.validate(async (valid) => {
				if (valid) {
				  try {
					const response = await addCustomChargeProject(this.customChargeForm);
					if (response.code === 200) {
					  this.$message.success('自定义收费项目添加成功！');
					  // 将新添加的项目添加到下拉选项中
					  const newItem = {
						id: response.data.id,
						label: this.customChargeForm.chargeProjectName,
						chargeProjectName: this.customChargeForm.chargeProjectName,
						priceCode: this.customChargeForm.priceCode,
						description: this.customChargeForm.description
					  };
					  
					  this.selectChanceAll.unshift(newItem);
					  this.addForm.chargeProjectName = response.data.id;
					  
					  this.customChargeDialogVisible = false;
					  this.resetCustomForm();
					} else {
					  this.$message.error(response.message || '添加失败');
					}
				  } catch (error) {
					console.error('添加自定义收费项目失败:', error);
					this.$message.error('添加失败，请重试');
				  }
				}
			  });
			},
			
			// 原有方法保持不变
			async loadData(){
				let res = await standardList({ name:this.inputSearchValue });
				if(res.code===200){
					this.selectChanceAll = res.data.map(v => {return { label: v.chargeProjectName, ...v}})
				}else{
					this.$message.error(res.message)
					this.selectChanceAll = [];
				}
			},
			
			getForm(){
				this.addForm = addForm.map(v => {return v })[0];
				this.formType = AddType.map(function(val) { return val })
			},
			
			async axiosGetSosTypes(){
				let rs = await getSosTypes();
				this.ClassIdOptions = rs.data.map(v=>{ return { label: v.name , ...v } })
			},
			
			async axiosGetCostType(){
			   let res = await getCostType();
			   this.expenseCategoryIdOptions = res.data.map(v=>{ return { label: v.name , ...v } });
			},
			
			async axiosGetMREC(){
				let res = await getMREC();
				this.CostIdOptions = res.data.map(v=>{ return { label: v.name , ...v } })
			},
			
			removeAllSpaces(str) {
			  return str.trim().replace(/\s+/g, '');
			},
			
			inputChance(v,i){
				console.log(v,i);
			},
			
			searchMethod(query, option) {
				query = this.removeAllSpaces(query);
				if(query){
					this.loading = true
					this.inputSearchValue = query
					this.pageNum = 0
					this.pageSize = 0
					this.loadData();
					this.loading = false
				}else{
					this.inputSearchValue = query
					this.pageNum = 1
					this.pageSize = 28
					this.loadData();
				}
			},
			
			async handlefoucs(v,i){
				this.idx = i;
				switch (i) {
					case 3: 
						this.loadData();
					break;
					case 6:
						this.axiosGetSosTypes();
					break;
					case 11:
						this.axiosGetCostType();
					break;
					case 12:
						this.axiosGetMREC();
					break;
				}
			},
			
			async addSubmit(){
				this.$refs.addForm.validate(async(valid) => {
				if(valid){
					let res = await addChargeProject(this.addForm)
					if (res.code === 200){
					this.$message({
						message:res.message,
						type:"success"
					});
						this.$refs.addForm.resetFields();
						this.parentMethod();
						this.dialogVisible = false
					}else{
						this.$refs.addForm.resetFields();
						this.$message({ message:res.message, type:"error" });
					}
				}
				});
			},
			
			handleChange(val){
				switch (this.idx) {
					case 3: 
						let nameObj = this.selectChanceAll.find(name => name.id === val)
						this.mergeObjects(this.addForm, nameObj);
						this.addForm.simpCode = this.makePy(this.addForm.chargeProjectName).toUpperCase()
					break;
				}
			},
			
			open(){
				this.dialogVisible = true;
			},
			
			handleClose(done){
				this.$confirm('确认关闭？')
				.then(_ => {
					this.$refs['addForm'].resetFields();
					done();
				})
				.catch(_ => {});
			},
			
			mergeObjects(A, B) {
			  for (const key in B) {
			    if (
			      B.hasOwnProperty(key) &&
			      A.hasOwnProperty(key) &&
			      B[key] !== undefined &&
			      B[key] !== null &&
			      B[key] !== ''
			    ) {
			      A[key] = B[key];
			    }
			  }
			  return A;
			}
		},
	}
</script>

<style lang="less" scoped>
	/deep/ .el-dialog__header{
		padding: 4px;
		background-color: #007bb0;
	}
	/deep/ .el-dialog__title{
		font-size: 12px;
		color: #fff;
	}
	/deep/ .el-dialog__headerbtn .el-dialog__close{
		color: #fff;
	}
	/deep/ .el-dialog__headerbtn{
		top: 10px;
	}
	.content {
		height: 100%;
		width: 100%;
		
		.main {
			.addModel{
				/deep/ .el-dialog__header{
					padding: 4px;
					background-color: #007bb0;
				}
				/deep/ .el-dialog__title{
					font-size: 12px;
					color: #fff;
				}
				/deep/ .el-dialog__headerbtn .el-dialog__close{
					color: #fff;
				}
				/deep/ .el-dialog__headerbtn{
					top: 10px;
				}
				.form{
					/deep/ .el-input--mini .el-input__inner{
						height: 26px;
					}
					/deep/ .el-form{
						padding: 12px;
						display: flex;
					}
					/deep/ .el-tabs--border-card{
						width: 100%;
					}
					/deep/ .el-form-item__content{
						display: flex;
						font-size: 12px;
					}
					/deep/ .el-form-item{
						margin-top: -8px;
					}
					/deep/ .el-form-item__label{
						font-size: 12px;
						display: flex;
					}
					/deep/ .el-select-dropdown__item{
						border: 1px solid #eeeeee;
						padding: 0;
						height: 28px;
						#optionItem {
							width: 100%;
							height: 100%;
							display: flex;
							align-items: center;
							text-align: center;
							justify-content: center;
							span{
								display: inline-block;
								font-size: 12px;
								width: 88px;
								height: 30px;
								line-height: 30px;
								white-space: nowrap;
								overflow: hidden;
								text-overflow: ellipsis;
							}
						}
					}
					
					/* 新增样式：选择框带添加按钮 */
					.select-with-add-button {
					  display: flex;
					  align-items: center;
					  gap: 8px;
					  
					  /deep/ .el-select {
						flex: 1;
					  }
					  
					  .add-button {
						flex-shrink: 0;
						width: 32px;
						height: 26px;
						padding: 0;
						background-color: #67c23a;
						border-color: #67c23a;
						color: white;
						
						&:hover {
						  background-color: #5daf34;
						  border-color: #5daf34;
						}
						
						&:active {
						  background-color: #529b2e;
						  border-color: #529b2e;
						}
					  }
					}
				}
			}
		}
	}
</style>